export default __webpack_public_path__ + "static/media/approve-for-work.b86e22ff.svg";